import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import axios from 'axios';
import { getUrlParam } from '@tencent/vft-common/util.esm';
import * as reporter from "./report";
import sign from "./sign";
;
var isDebug = Number(getUrlParam('debug') || getUrlParam('sandbox')) === 1;
var newLoginCgi = "https://".concat(isDebug ? 't' : '', "pbaccess.video.qq.com/trpc.video_account_login.web_login_trpc.WebLoginTrpc");
export function RequestError(code, msg, res) {
  this.code = code;
  this.msg = msg;
  this.res = res;
}
RequestError.prototype.toString = function () {
  return this.msg + (this.code ? "(".concat(this.code, ")") : '');
};
export function doRequest(_x, _x2) {
  return _doRequest.apply(this, arguments);
}
function _doRequest() {
  _doRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(cmd, params) {
    var signInfo, _yield$axios$post, responseData, status, statusText, _ref, data, ret, msg;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return sign.getSignInfo();
          case 2:
            signInfo = _context.sent;
            _context.next = 5;
            return axios.post("".concat(newLoginCgi, "/").concat(cmd), _objectSpread({
              si: signInfo
            }, params), {
              headers: {
                'Content-Type': 'application/json'
              },
              type: 'POST',
              timeout: 5000,
              withCredentials: true
            });
          case 5:
            _yield$axios$post = _context.sent;
            responseData = _yield$axios$post.data;
            status = _yield$axios$post.status;
            statusText = _yield$axios$post.statusText;
            if (!(status !== 200)) {
              _context.next = 11;
              break;
            }
            throw new RequestError(status, statusText, responseData);
          case 11:
            _ref = responseData || {}, data = _ref.data, ret = _ref.ret, msg = _ref.msg;
            if (!(ret !== 0 || !data)) {
              _context.next = 14;
              break;
            }
            throw new RequestError(ret, msg, data);
          case 14:
            if (!(data.errcode !== 0)) {
              _context.next = 16;
              break;
            }
            throw new RequestError(data.errcode, data.err_msg, data);
          case 16:
            return _context.abrupt("return", data);
          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _doRequest.apply(this, arguments);
}
export function request(_x3, _x4) {
  return _request.apply(this, arguments);
}

/**
 * 登录换票
 * @returns
 */
function _request() {
  _request = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(cmd, params) {
    var reportParams, startTime, data;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            reportParams = {
              f_event: reporter.EVENT_INIT_REQUEST,
              f_cgi: cmd,
              f_cgi_param: JSON.stringify(params)
            };
            startTime = Date.now();
            _context2.prev = 2;
            _context2.next = 5;
            return doRequest(cmd, params);
          case 5:
            data = _context2.sent;
            reportParams.f_errcode = 0;
            reportParams.f_cost = Date.now() - startTime;
            reporter.report(reportParams);
            return _context2.abrupt("return", data);
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](2);
            reportParams.f_errcode = _context2.t0.code;
            reportParams.f_errmsg = _context2.t0.msg;
            reportParams.f_cost = Date.now() - startTime;
            reporter.report(reportParams);
            throw _context2.t0;
          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 12]]);
  }));
  return _request.apply(this, arguments);
}
export function authLogin() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request('NewLogin', params);
}

/**
 * 刷票据
 * @returns
 */
export function authRefresh() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request('NewRefresh', params);
}

/**
 * 退出登录
 * @returns
 */
export function authLogout() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request('NewLogout', params);
}

/**
 * 第三方登录换票
 * @param {String} type
 * @param {Object} params
 * @returns
 */
export function thirdLogin(_x5, _x6) {
  return _thirdLogin.apply(this, arguments);
}

/**
 * 校验登录态
 * @param {Object} params
 * @returns
 */
function _thirdLogin() {
  _thirdLogin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type, params) {
    var _yield$axios$post2, data;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return axios.post("//vip.video.qq.com/fcgi-bin/comm_cgi?name=third_login&otype=xjson&type=".concat(type), params, {
              dataType: 'json',
              withCredentials: true,
              timeout: 2000
            });
          case 2:
            _yield$axios$post2 = _context3.sent;
            data = _yield$axios$post2.data;
            return _context3.abrupt("return", data);
          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _thirdLogin.apply(this, arguments);
}
export function checkLogin(_x7) {
  return _checkLogin.apply(this, arguments);
}
function _checkLogin() {
  _checkLogin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(params) {
    var _yield$axios$get, data;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return axios.get('//vip.video.qq.com/fcgi-bin/comm_cgi?name=check_login&otype=xjson', {
              params: params,
              withCredentials: true,
              timeout: 6000
            });
          case 2:
            _yield$axios$get = _context4.sent;
            data = _yield$axios$get.data;
            return _context4.abrupt("return", data);
          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _checkLogin.apply(this, arguments);
}